<app-side-menu>
  <div class="vehicle-rentals-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <div *ngIf="loadingStatuses" class="loading-statuses">
            <i class="fas fa-spinner fa-spin me-2"></i>
            Carregando status...
          </div>
          <select
            *ngIf="!loadingStatuses"
            id="statusFilter"
            class="form-select"
            [(ngModel)]="filters.status"
            (change)="applyFilters()">
            <option *ngFor="let option of statusOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="priorityFilter" class="form-label">Filtrar por Prioridade:</label>
          <select
            id="priorityFilter"
            class="form-select"
            [(ngModel)]="filters.priority"
            (change)="applyFilters()">
            <option *ngFor="let option of priorityOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="filter-actions">
          <button
            type="button"
            class="btn btn-outline-success"
            (click)="exportToCSV()">
            <i class="fas fa-file-csv me-2"></i>
            Exportar CSV
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Card da Lista com Loading Overlay (igual Customer) -->
    <div class="vehicle-rentals-card">
      <!-- Loading dentro do card -->
      <!-- Tabela de Locações - Sempre visível para manter o header -->
      <div *ngIf="!error">
        <app-table
          [title]="tableTitle"
          [columns]="columns"
          [data]="filteredVehicleRentals"
          [loading]="isLoading"
          [showSearch]="showSearch"
          [searchPlaceholder]="searchPlaceholder"
          [clickable]="clickable"
          [actions]="actions"
          [disablePagination]="false"
          [totalItemsFromBackend]="totalItems"
          [searchTerm]="filters.search"
          (actionClick)="onActionClick($event)"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (searchChange)="onSearchChange($event)">
          <app-button
            table-header-action
            text="Exportar CSV"
            [color]="'var(--success-color, #16a34a)'"
            [height]="'42px'"
            className="export-btn"
            (buttonClick)="exportToCSV()">
          </app-button>
          <app-button
            *appHasPermission="'VehicleRentals.Create'"
            table-header-action
            text="Nova Locação"
            [color]="'var(--primary-light)'"
            [height]="'42px'"
            className="new-rental-btn"
            (buttonClick)="createNewRental()">
          </app-button>
        </app-table>
      </div>

      <!-- Estado Vazio - Mostrar apenas quando não há resultados e não está carregando -->
      <div *ngIf="!isLoading && !error && filteredVehicleRentals.length === 0" class="empty-state-simple">
        <div class="empty-message">
          <i class="fas fa-car"></i>
          <p>Nenhuma locação encontrada</p>
        </div>
      </div>
    </div>

    

    <!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>
</app-side-menu>
